import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useMemo, useState } from 'react';
import Announcer from "./Announcer";
import AnnouncerContext from "./AnnouncerContext";
import { LiveRegionRole } from "./interfaces";
import { jsx as ___EmotionJSX } from "@emotion/core";

var LiveAnnouncer = function LiveAnnouncer(_ref) {
  var children = _ref.children;

  var _useState = useState(undefined),
      _useState2 = _slicedToArray(_useState, 2),
      politeLogMessage = _useState2[0],
      setPoliteLogMessage = _useState2[1];

  var _useState3 = useState(undefined),
      _useState4 = _slicedToArray(_useState3, 2),
      politeStatusMessage = _useState4[0],
      setPoliteStatusMessage = _useState4[1];

  var _useState5 = useState(undefined),
      _useState6 = _slicedToArray(_useState5, 2),
      assertiveLogMessage = _useState6[0],
      setAssertiveLogMessage = _useState6[1];

  var _useState7 = useState(undefined),
      _useState8 = _slicedToArray(_useState7, 2),
      assertiveStatusMessage = _useState8[0],
      setAssertiveStatusMessage = _useState8[1];

  var announcePolite = function announcePolite(_ref2) {
    var region = _ref2.region,
        role = _ref2.role;

    switch (role) {
      case LiveRegionRole.Status:
        setPoliteStatusMessage(region);
        return;

      case LiveRegionRole.Log:
        setPoliteLogMessage(region);
        return;

      default:
        return;
    }
  };

  var announceAssertive = function announceAssertive(_ref3) {
    var region = _ref3.region,
        role = _ref3.role;

    switch (role) {
      case LiveRegionRole.Status:
        setAssertiveStatusMessage(region);
        return;

      case LiveRegionRole.Log:
        setAssertiveLogMessage(region);
        return;

      default:
        return;
    }
  };

  var updateFunctions = useMemo(function () {
    return {
      announceAssertive: announceAssertive,
      announcePolite: announcePolite
    };
  }, []);
  return ___EmotionJSX(AnnouncerContext.Provider, {
    value: updateFunctions
  }, children, ___EmotionJSX(Announcer, {
    politeLogRegion: politeLogMessage,
    politeStatusRegion: politeStatusMessage,
    assertiveLogRegion: assertiveLogMessage,
    assertiveStatusRegion: assertiveStatusMessage
  }));
};

export default LiveAnnouncer;